export default "__VITE_ASSET__BoMS6PqG__"